export default __webpack_public_path__ + "static/media/cancel.65303c63.svg";